<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      show-save-button
      unit="企业信息"
      edit-title
      id-key="EntId"
      :data="data"
      close-on-saved
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @edit-opened="onEditOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="EntName">
              <el-input v-model="data.EntName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业性质" prop="Nature">
              <el-select v-model="data.Nature" style="width:100%">
                <el-option label="国有企业" :value="0"></el-option>
                <el-option label="事业单位" :value="1"></el-option>
                <el-option label="集体所有制企业" :value="2"></el-option>
                <el-option label="联营企业" :value="3"></el-option>
                <el-option label="三资企业" :value="4"></el-option>
                <el-option label="私营企业" :value="5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="Phone">
              <el-input v-model="data.Phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业法人" prop="Legal">
              <el-input v-model="data.Legal"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="企业地址" prop="Address">
              <el-input type="textarea" v-model="data.Address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">企业Logo</el-divider>
        <el-row>
          <el-col :span="24">
            <single-photo-upload v-model="data.Logo" :upload-url="'/api' + api.uploadLogo" />
          </el-col>
        </el-row>
        <el-divider content-position="left">企业简介</el-divider>
        <el-row>
          <el-col :span="24">
            <intro-editor v-model="data.Intro" />
          </el-col>
        </el-row>
        <el-divider content-position="left">资质荣誉</el-divider>
        <el-row>
          <el-col :span="24">
            <honer-editor v-model="data.Honer" />
          </el-col>
        </el-row>
        <el-divider content-position="left">饲养环境</el-divider>
        <el-row>
          <el-col :span="24">
            <environment-editor v-model="data.Environment" />
          </el-col>
        </el-row>
        <el-divider content-position="left">饲养过程</el-divider>
        <el-row>
          <el-col :span="24">
            <process-editor v-model="data.Process" />
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

import singlePhotoUpload from "@/components/common/photo/singleUpload";
import introEditor from "@/components/common/editor";
import honerEditor from "@/components/common/editor";
import environmentEditor from "@/components/common/editor";
import processEditor from "@/components/common/editor";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePhotoUpload,
    introEditor,
    honerEditor,
    environmentEditor,
    processEditor,
  },
  data() {
    return {
      data: {
        EntId: 0,
        EntName: "",
        Nature: null,
        Phone: "",
        Legal: "",
        Address: "",
        Logo: "",
        Intro: "", //简介
        Honer: "", //资质荣誉
        Environment: "", //饲养环境
        Process: "", //饲养过程
      },
      api: require("@/api/ent/ent").default,
      rules: {
        EntName: [{ required: true, message: "请填写企业名称" }],
        Nature: [{ required: true, message: "请选择企业性质" }],
      },
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      console.log(data, "onEditOpened");
      this.api.getMyInfo().then((res) => {
        this.data = res.Data;
      });
    },
    onenDpDialog() {
      this.$refs.dpDialog.open().then((that) => {
        that.$refs.list.getData();
      });
    },
    setParent(dp) {
      this.$refs.dpSelectInput.setName(dp.DpName);
      this.data.DpId = dp.DpId;
    },
  },
};
</script>